const isDebugMode = process.env.SVELTE_APP_GRAPPLE_STAGE !== 'prd';

export const debugLog = (...args: any[]): void => {
  if (isDebugMode) {
    console.log('[mbdcb]', ...args);
  }
};
